<!-- FacebookCallback.vue -->
<template>
  <div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center">
    الرجاء الانتظار قليلا ...
  </div>
</template>

<script>
import AuthApi from '@/api/auth'
import InstagramAccountsApi from '@/api/instagram/account'
import { redirectToHomeIfInWebView } from '@/utils/flutter-webview'

export default {
  async mounted() {
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get('code')
    const state = urlParams.get('state')
    const isLogin = state.includes('_login')
    const isInstagram = state.includes('_insta')
    console.log(isLogin)
    console.log(isInstagram)
    if (!code) {
      console.error('No code returned from Facebook')
      this.$router.push({ name: 'login' })
      return
    }
    const self = this
    try {
      const response = await AuthApi.loginByCode({ code, state, instagram: isInstagram ? 'yes' : 'no' })
      const accessToken = response?.access_token
      console.log(response)
      if (!accessToken) this.$router.push({ name: 'login' })
      if (isInstagram) await this.addInstagramAccount({ token: accessToken })
      else await this.login({ token: accessToken }, isLogin)
    } catch (error) {
      if (redirectToHomeIfInWebView(self.$router)) return
      self.$router.push({ name: 'owner:home' })
      this.$router.push('/login')
      this.$store.commit('auth/SET_LOADER', false)
    }
  },
  methods: {
    async addInstagramAccount(data) {
      InstagramAccountsApi.addAccount(data).then(res => {
        if (res.error === 0) {
          this.$store.commit('instagram/SET_INSTA_ACCOUNTS', res.accounts)
          if (redirectToHomeIfInWebView(this.$router)) return
          this.$router.push({ name: 'owner:home' })
        } else {
          this.$notifyError(this.$t('auth.fail-message'))
        }
      }).catch(e => { this.error = e }).finally(() => {
        this.loading = false
        this.$store.commit('auth/SET_LOADER', false)
      })
    },
    async login(data, redirect = true) {
      const self = this
      AuthApi.loginFb(data, redirect).then(res => {
        if (res.access_token) {
          self.$store.dispatch('auth/PREPARE_USER', { ...res })
          if (redirectToHomeIfInWebView(self.$router)) return
          self.$router.push({ name: 'owner:home' })
        } else {
          self.$notifyError(this.$t('auth.fail-message'))
        }
      }).catch(e => { this.error = e }).finally(() => {
        this.$store.commit('auth/SET_LOADER', false)
      })
    },
  },
}
</script>
